import React from 'react';
import { ChevronRight } from 'lucide-react';

const ContentCard = ({ 
  title, 
  subtitle, 
  icon: Icon,
  children,
  onClick,
  actionLabel,
  className = '',
  variant = 'default' // 'default', 'highlight', 'subtle'
}) => {
  const variants = {
    default: 'bg-white border border-gray-100',
    highlight: 'bg-gradient-to-br from-[var(--primary)] to-[var(--primary-dark)] text-white',
    subtle: 'bg-gray-50 border border-gray-100'
  };

  const isClickable = onClick || actionLabel;

  return (
    <div 
      className={`rounded-xl p-4 shadow-sm ${variants[variant]} ${isClickable ? 'cursor-pointer hover:shadow-md transition-shadow' : ''} ${className}`}
      onClick={onClick}
      data-testid="content-card"
    >
      <div className="flex items-start gap-3">
        {Icon && (
          <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${
            variant === 'highlight' ? 'bg-white/20' : 'bg-[var(--primary)]/10'
          }`}>
            <Icon className={`w-5 h-5 ${variant === 'highlight' ? 'text-white' : 'text-[var(--primary)]'}`} />
          </div>
        )}
        
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <h3 className={`font-heading font-semibold ${
              variant === 'highlight' ? 'text-white' : 'text-[var(--primary)]'
            }`}>
              {title}
            </h3>
            {isClickable && (
              <ChevronRight className={`w-5 h-5 flex-shrink-0 ${
                variant === 'highlight' ? 'text-white/70' : 'text-gray-400'
              }`} />
            )}
          </div>
          
          {subtitle && (
            <p className={`text-sm mt-0.5 ${
              variant === 'highlight' ? 'text-white/80' : 'text-gray-500'
            }`}>
              {subtitle}
            </p>
          )}
          
          {children && (
            <div className="mt-3">
              {children}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentCard;
